import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'prepaid-balance',
    pluginName: 'ACCOUNT',
    entityName: 'PREPAID_BALANCE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch PrepaidBalance action creators
export const fetchPrepaidBalanceInit = () => {
    return crudActions.fetchInit();
};
export const fetchPrepaidBalancetart = () => {
    return crudActions.fetchStart();
};
export const fetchPrepaidBalanceSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchPrepaidBalanceFail = () => {
    return crudActions.fetchFail();
};
export const fetchPrepaidBalanceCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("balance/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch prepaid balance."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch prepaid balance."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
};

export const fetchPrepaidBalance = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("balance/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
};

export const fetchTopupPriceList = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("topup/get-price-list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
};

export const createTopUpInit = () => {
    return crudActions.createInit();
};
export const createTopUpStart = () => {
    return crudActions.createStart();
};
export const createTopUpSuccess = createdTopUp => {
    return crudActions.createSuccess(createdTopUp);
};
export const createTopUpFail = error => {
    return crudActions.createFail(error);
};

export const createTopUp = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createTopUpStart());
        try {
            let res = await rest.post('/topup/bulk-create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created top up.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createTopUpFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create top up."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create top up."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createTopUpFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const loadTopupInit = () => {
    return crudActions.createInit();
};
export const loadTopupStart = () => {
    return crudActions.createStart();
};
export const loadTopupSuccess = createdTopUp => {
    return crudActions.createSuccess(createdTopUp);
};
export const loadTopupFail = error => {
    return crudActions.createFail(error);
};

export const onLoadTopup = topup => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(loadTopupStart());
            let res = await rest.post('/topup/load', topup);
            if (res.data && res.data.succeeded) {
                dispatch(loadTopupSuccess({
                    list: res.data.result.data,
                    count: -1
                }));
                return { data: res.data.result.data, count: 0 }
            }
            else {
                dispatch(loadTopupFail());

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            dispatch(loadTopupFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const loadAccountInit = () => {
    return crudActions.createInit();
};
export const loadAccountStart = () => {
    return crudActions.createStart();
};
export const loadAccountSuccess = createdTopUp => {
    return crudActions.createSuccess(createdTopUp);
};
export const loadAccountFail = error => {
    return crudActions.createFail(error);
};

export const onLoadAccount = account => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(loadAccountStart());
            let res = await rest.post('/account/load', account);
            if (res.data && res.data.succeeded) {
                dispatch(loadAccountSuccess({
                    list: res.data.result.data,
                    count: -1
                }));
                return { data: res.data.result.data, count: 0 }
            }
            else {
                dispatch(loadAccountFail());

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            dispatch(loadAccountFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};


export const fetchTopupCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("topup/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch topup count."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch topup count."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
};

export const fetchTopupList = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("topup/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
};


export const bulkDeleteTopupsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteTopupsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteTopupsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteTopupsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteTopups = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteTopupsStart());
        try {
            let res = await rest.post('/topup/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteTopupsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted topups.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteTopupsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete topups."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete topups."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteTopupsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};